export function ProjectViewModel(data) {
  this.Id = data.Id;
  this.Name = data.Name;
  this.Description = data.Description;
  this.EndpointId = data.EndpointId;
  this.StackId = data.StackId;
  this.OwnerId = data.OwnerId;
  this.PublishedPort = data.PublishedPort;
  this.Subdomain = data.Subdomain;
  this.CreatedAt = data.CreatedAt;
  this.UpdatedAt = data.UpdatedAt;
  this.StackName = data.StackName;
  this.URL = data.URL;
}
